import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { createBrowserRouter, RouterProvider, ScrollRestoration } from 'react-router-dom';
import Layout from './Features/Layout';
import routes from './routes';

// MSAL imports
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { MsalProvider } from '@azure/msal-react';
import { MantineProvider } from '@mantine/core';
export const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

// Optional - This will update account state if a user signs in from another tab or window
msalInstance.enableAccountStorageEvents();

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && (event.payload as any).account) {
    const account = (event.payload as any).account;
    msalInstance.setActiveAccount(account);
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const router = createBrowserRouter([
  {
    element: (
      <MsalProvider instance={msalInstance}>
        <MantineProvider
          theme={{
            breakpoints: {
              xs: 576,
              sm: 768,
              md: 992,
              lg: 1200,
              xl: 1920,
            },
            colors: {
              'avensia-turqoise': [
                '#D9F6DC',
                '#C1EFCE',
                '#A9E8C7',
                '#92E0C5',
                '#7BD8C9',
                '#65CDCF',
                '#4fadc6',
                '#4074A7',
                '#314488',
                '#272367',
              ],
              'avensia-blue': [
                '#7BA8E8',
                '#6B9CE3',
                '#5C91DE',
                '#4E86D8',
                '#407BD1',
                '#3270ca',
                '#285EAD',
                '#1F4D8F',
                '#173B70',
                '#0F2037',
              ],
            },
            primaryColor: 'avensia-blue',
          }}
        >
          <Layout />
          <ScrollRestoration />
        </MantineProvider>
      </MsalProvider>
    ),
    children: routes.map((route) => {
      return { ...route };
    }),
  },
]);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
